module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.6608/assets/images/snowflake.jpg"